import { h, Component } from 'preact';
import { getValueForClientSize } from 'utils/bolt';
import { joinClasses } from 'utils/utils';
import tryToPlayVideo from 'utils/tryToPlayVideo';
import * as webp from 'utils/bolt/webp';
import { useDynamicAssetFolder } from 'utils/assets';
import Store from 'store/store';
import s from 'components/bolt/sectionBackground/sectionBackground.sss';

export default class SectionBackground extends Component {
	constructor(props) {
		super(props);

		this.state = {
			posterVisible: true,
			bgVideoHidden: false,
			removeBgVideo: false,
			videoPlaySuccess: false,
		};

		this.playVideo = this.playVideo.bind(this);
		this.removeBgVideo = this.removeBgVideo.bind(this);
		this.hidePoster = this.hidePoster.bind(this);

		const bg = getValueForClientSize(this.props.data);
		if (bg.tiled && !bg.tileSize) {
			const img = new Image();
			img.onload = () => {
				this.tileSize = img.naturalWidth;
			};
			img.src = bg.asset;
		}
	}

	componentDidMount() {
		// If PLAY_BACKGROUND_VIDEO is emitted (from user first interacting with page), try to play the video
		Store.on('PLAY_BACKGROUND_VIDEO', this.playVideo);
		this.playVideo();
	}

	componentWillUnmount() {
		Store.off('PLAY_BACKGROUND_VIDEO', this.playVideo);
	}

	playVideo() {
		if (this.state.removeBgVideo || this.state.videoPlaySuccess) return;
		if (!this.state.bgVideoHidden) {
			// try to autoplay the bg video on page load
			tryToPlayVideo(this.video, true).then(
				() => {
					this.hidePoster();
					this.setState({ videoPlaySuccess: true });
				}
			).catch(
				// if it fails, hide the video (and use the fallback image instead)
				() => {
					this.setState({ bgVideoHidden: true });
				}
			);
		} else {
			// when user first touches screen, try to play the video again
			tryToPlayVideo(this.video).then(
				() => {
					this.hidePoster();
					this.setState({ bgVideoHidden: false, videoPlaySuccess: true });
				}
			// if it still fails, remove it completely
			).catch(this.removeBgVideo);
		}
	}

	removeBgVideo() {
		this.setState({
			removeBgVideo: true
		});
	}

	hidePoster() {
		this.setState({
			posterVisible: false,
		});
	}

	getBgValue(field) {
		const { data } = this.props;
		if (!data || !data.desktop && !data.tablet && !data.mobile) {
			return undefined;
		}

		let bgValue = {};

		Object.entries(data).map(([device, data]) => {
			bgValue[device] = data[field];
		});

		return useDynamicAssetFolder(getValueForClientSize(bgValue));
	}

	forceBgSize({ height }) {
		if (height && height !== 'auto' && !height.endsWith?.('px')) {
			height += 'px';
		}
		this.wrapper.style.height = height || '';
	}

	renderBgVideo(bg) {
		const { posterVisible, removeBgVideo, bgVideoHidden } = this.state;
		const preloadImg = this.getBgValue('preLoadImg');
		const fallbackFormat = this.props.data?.alternativeImageFormat || 'jpg';

		return (
			<div class={s.bgVideo} onTouchStart={this.playVideo}>
				{!removeBgVideo && (
					<video
						ref={ref => this.video = ref}
						class={joinClasses(s.video, bgVideoHidden && s.hide)}
						style={{ objectPosition: bg.bgPosition || 'center' }}
						poster={preloadImg}
						autoPlay
						muted
						playsInline
						loop={!bg.disableLoop}
						//onCanPlay={this.playVideo}
						key={`${bg.asset || bg.fallbackImg || bg.preLoadImg || 'video'}-video`}
					>
						{bg.asset.endsWith('.webm') && <source src={bg.asset} type="video/webm" />}
						<source src={bg.asset.replace(/\.[^./]+$/, '.mp4')} type="video/mp4" />
					</video>
				)}
				{(posterVisible && preloadImg) && <webp.Picture src={preloadImg} alt="" fallbackFormat={fallbackFormat} key="preload" />}
			</div>
		);
	}

	render({ data }) {
		const bg = getValueForClientSize(data);
		let isVideo;
		const wrapperStyle = {};

		if (bg?.asset) {
			const asset = bg.asset.trim();
			isVideo = asset.endsWith('webm') || asset.endsWith('mp4');
			wrapperStyle.backgroundImage = isVideo ? `url(${bg.fallbackImg})` : `url(${bg.asset})`;
			wrapperStyle.backgroundPosition = bg.bgPosition || 'center';
		}

		if (bg.tiled) {
			wrapperStyle.backgroundSize = bg.tileSize || this.tileSize || 'cover';
		}

		if (bg.backgroundColor) {
			const variables = Store.get().appData.styling.variables;
			wrapperStyle.backgroundColor = variables[bg.backgroundColor.substring(1)] || bg.backgroundColor;
		}

		return (
			<div
				ref={ref => this.wrapper = ref}
				class={joinClasses(s.wrapper, bg.tiled && s.tiled)}
				style={wrapperStyle}
			>
				{isVideo && this.renderBgVideo(bg)}
			</div>
		);
	}
}